// @flow
/**
 * The type of (redux) action which signals that i18next has been initialized.
 */
export const I18NEXT_INITIALIZED = 'I18NEXT_INITIALIZED';
/**
 * The type of (redux) action which signals that language has been changed.
 */
export const LANGUAGE_CHANGED = 'LANGUAGE_CHANGED';
